import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  message: null,
  error: null,
  data: [],
};

const getLiveInSlice = createSlice({
  name: "getLiveIn",
  initialState,
  reducers: {
    getLiveInStart(state, payload) {
      state.loading = true;
      state.error = null;
      state.message = null;
    },

    getLiveInSuccess(state, action) {
      state.loading = false;
      const flattenedArray = []?.concat(...action?.payload);
      state.data = flattenedArray;
      state.message = action.payload.message;
    },
    getLiveInFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.message = null;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearMessage: (state) => {
      state.message = null;
    },
  },
});

export const {
  getLiveInStart,
  getLiveInSuccess,
  getLiveInFailure,
  clearError,
  clearMessage,
} = getLiveInSlice.actions;

export default getLiveInSlice.reducer;
